import { render, staticRenderFns } from "./BadgeForm.vue?vue&type=template&id=60240594&"
import script from "./BadgeForm.vue?vue&type=script&lang=js&"
export * from "./BadgeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports